import { render, staticRenderFns } from "./Wp_jd_select_simple.vue?vue&type=template&id=63121718&scoped=true&"
import script from "./Wp_jd_select_simple.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_select_simple.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_select_simple.vue?vue&type=style&index=0&id=63121718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63121718",
  null
  
)

export default component.exports